import Vuex from 'vuex'
import Vue from 'vue'
import { HTTP } from '@/api'
import moment from 'moment'

Vue.use(Vuex)

export default new Vuex.Store({
	state() {
		return {
			initialLoad: true,
			video: null,
			currentChapter: null,
			currentPlayingChapter: null,
			audio: null,
			episodeData: null,
			showEpisode: false,
			showWebsite: false,
			currentDate: null, 
			schedule: [],
			weekendEpisodes: [],
			episodeType: '',
			// CVDD
			counter: 0,
			// Brood Sorteren
			attemps: false,
			newSpots: [],
			newBreads: [],
			// Weekend
			currentLevel: 0,
			vevColors: ['BLAUW', 'BRUIN', 'GEEL', 'GRIJS', 'ZWART', 'BLAUWV2'],
			showPotatoheadsGame: false,
			showBoterhamGooienGame: false,
			liftButtons: [
				{
					game: 'REGIE',
					level: '8',
					chapter: 'LIFT_REGIE'
				},
				{
					game: 'VEV',
					level: '5',
					chapter: 'LIFT_STUDIO'
				},
				{
					game: 'DRUMMEN',
					level: '4',
					chapter: 'LIFT_STUDIO'
				},
				{
					game: 'verkeerd',
					level: '11',
					chapter: 'LIFT_NOGMAALS'
				},
				{
					game: 'UITGANG',
					level: '0',
					chapter: 'LIFT_EIND'
				}
			],
			liftButtonsV2: [
				{
					game: 'VP',
					level: '12',
					chapter: 'LIFT_OKEDAN'
				},
				{
					game: 'LOPENDEBAND',
					level: '5',
					chapter: 'LIFT_GOEDEKEUZE'
				},
				{
					game: 'KRIJTBORD',
					level: '3',
					chapter: 'LIFT_SUPERLEUK'
				},
				{
					game: 'VERKEERDEETAGE',
					level: '2',
					chapter: 'LIFT_NOGMAALS'
				},
				{
					game: 'REGIE',
					level: '8',
					chapter: 'LIFT_YESGAANWEDOEN'
				},
				{
					game: 'UITGANG',
					level: '0',
					chapter: 'LIFT_EIND'
				}
			],
			liftButtonsV3: [
				{
					game: 'REGIE',
					level: '8',
					chapter: 'LIFT_DUIMOMHOOG'
				},
				{
					game: 'CAMERASPEL',
					level: '5',
					chapter: 'LIFT_OKE'
				},
				{
					game: 'METERKAST',
					level: '7',
					chapter: 'LIFT_KOMMEE'
				},
				{
					game: 'VERKEERDEETAGE',
					level: '14',
					chapter: 'LIFT_VASTLEUK'
				},
				{
					game: 'UITGANG',
					level: '0',
					chapter: 'LIFT_NAAR_UITGANG'
				}
			],
			//WK LOPENDEBAND
			failedNextChapter: '',
			currentVersion: '',
			lopendebandGames: ['13', '36', '43'],
			lopendebandGamesV2: ['10', '19', '23'],
			podcasts: []
		}
	},
	getters: {
		getTodaysEpisode: (state) => { 
			const now = moment()
			const newEpisodeTime = moment('07:45', 'HH:mm')
			const episodeType = state.schedule.filter(item => item.date == state.currentDate).map(filteredObj => filteredObj.episodes[0]._link)
			if (episodeType === 'WeekendEpisodes') {
				return state.schedule.filter(item => item.date == state.currentDate)
			} else {
				if(moment().day() === 1 && now.isBefore(newEpisodeTime)) {
					var lastFriday = now.subtract(3, "days").format('YYYY-MM-DD')
					const episodeTypeLastFriday = state.schedule.filter(item => item.date == lastFriday).map(filteredObj => filteredObj.episodes[0]._link)
					if (episodeTypeLastFriday[0] === 'Episodes') {
						return state.schedule.filter(item => item.date == lastFriday)
					} 
				} else {
					if (now.isBefore(newEpisodeTime)) {
						var oneDayBefore = now.subtract(1, "days").format('YYYY-MM-DD')
						return state.schedule.filter(item => item.date == oneDayBefore)
					} else {
						return state.schedule.filter(item => item.date == state.currentDate)
					}
				}
			}
			return []
		},
		lastFiveEpisodes: (state) => {
			const now = moment()
			const newEpisodeTime = moment('07:45', 'HH:mm')
			const date = (now.isBefore(newEpisodeTime)) ? now.subtract(1, "days").format('YYYY-MM-DD') : moment(state.currentDate).format('YYYY-MM-DD')
			return state.schedule.filter(item => moment(item.date).isSameOrBefore(moment(date), 'day') && item.episodes[0]._link === 'Episodes').slice(-5)
		},
		podcasts: (state) => state.podcasts
	},
	mutations: {
		SET_INITIAL_LOAD(state, initialLoad) {
			state.initialLoad = initialLoad
		},
		SET_VIDEO(state, video) {
			state.video = video
		},
		SET_CURRENT_CHAPTER(state, currentChapter) {
			state.currentChapter = currentChapter
			state.video.currentTime = state.episodeData.timeline[currentChapter].In
		},
		SET_CURRENT_PLAYING_CHAPTER(state, currentChapter) {
			state.currentPlayingChapter = currentChapter
		},
		SET_AUDIO(state, audio) {
			state.audio = audio
		},
		SET_EPISODE_DATA(state, data) {
			state.episodeData = data
		},
		CHANGE_TIMELINE(state, data) {
			state.episodeData.timeline[data.key].NextChapter = data.value
		},
		SHOW_EPISODE(state, data) {
			state.showEpisode = data
		},
		SHOW_WEBSITE(state, data) {
			state.showWebsite = data
		},
		SET_DATE(state, date) {
			state.currentDate = date
		},
		SET_SCHEDULE(state, schedule) {
			state.schedule = schedule
		},
		SET_WEEKENDEPISODES(state, episodes) {
			state.weekendEpisodes = episodes
		},
		SET_EPISODE_TYPE(state, episodeType) {
			state.episodeType = episodeType
		},
		// CVDD
		UPDATE_COUNTER(state, counter) {
			state.counter = counter
		},
		// BROOD SORTEREN
		SET_BROODSORTEREN_SPOTS(state, spots) {
			state.newSpots = spots
		},
		SET_BROODSORTEREN_BREADS(state, breads) {
			state.newBreads = breads
		},
		SET_BROODSORTEREN_ATTEMPS(state, attemps) {
			state.attemps = attemps
		},
		// WEEKEND
		SET_CURRENT_LEVEL(state, currentLevel) {
			state.currentLevel = currentLevel
		},
		SET_VEV_COLORS(state, vevColors) {
			state.vevColors = vevColors
		},
		SHOW_POTATOHEADS_GAME(state, showPotatoheadsGame) {
			state.showPotatoheadsGame = showPotatoheadsGame
		},
		SHOW_BOTERHAMGOOIEN_GAME(state, showBoterhamGooienGame) {
			state.showBoterhamGooienGame = showBoterhamGooienGame
		},		
		REMOVE_LIFT_BUTTON(state, index) {
			state.liftButtons.splice(index, 1)
		},
		REMOVE_LIFT_BUTTON_V2(state, index) {
			state.liftButtonsV2.splice(index, 1)
		},
		REMOVE_LIFT_BUTTON_V3(state, index) {
			state.liftButtonsV3.splice(index, 1)
		},
		REMOVE_LOPENDEBAND(state, version) {
			var index = state.lopendebandGames.indexOf(version)
			state.lopendebandGames.splice(index, 1)
		},
		RESET_LOPENDEBAND(state, items) {
			state.lopendebandGames = items
		},		
		REMOVE_LOPENDEBAND_V2(state, version) {
			var index = state.lopendebandGamesV2.indexOf(version)
			state.lopendebandGamesV2.splice(index, 1)
		},
		SET_LIFT_BUTTONS(state, data) {
			state.liftButtons = data
		},
		SET_FAILED_NEXT_CHAPTER(state, data) {
			state.failedNextChapter = data
		},
		SET_CURRENT_VERSION(state, data) {
			state.currentVersion = data
		},
		SET_PODCASTS(state, podcasts) {
			state.podcasts = podcasts
		}
	},
	actions: {
		getSchedule ({ commit }) {

				   HTTP.get('schedule.json')
					   .then((response) => {
						   const data = Array.isArray(response.data) ? response.data : response.data.entries
						   commit('SET_SCHEDULE', data)
					   }, (error) => {
						   console.log(error)
					   })
		},
		   getWeekendEpisodes ({ commit }) {
				   HTTP.get('weekend-episodes.json')
					   .then((response) => {
						   const data = Array.isArray(response.data) ? response.data : response.data.entries
						   commit('SET_WEEKENDEPISODES', data)
					   }, (error) => {
						   console.log(error)
					   })
		},		
		getPodcasts ({ commit }) {
			HTTP.defaults.baseURL = '/'
			HTTP.get('/static/data/podcast.json')
				.then((response) => {
					commit('SET_PODCASTS', response.data)
				}, (error) => {
					console.log(error)
				})
		},
		getEpisode ({ commit }, episode) {
			HTTP.defaults.baseURL = '/'
			console.log(episode.episode)
			return new Promise((resolve, reject) => {
				HTTP.get(`/static/data/${episode.episode}.json`)
					.then((response) => {	
						if(response !== undefined) {						
							console.log(response)
							const episodeType = response.data.name.includes('wk') ? 'weekendEpisode' : 'episode'

							commit('SET_EPISODE_TYPE', episodeType)
							commit('SET_EPISODE_DATA', response.data)							
							   // Use CDN for audio sprite if running locally
							   let audioSrc = response.data.audio.src;
							   if (process.env.NODE_ENV === 'development' && typeof process.env.AUDIO_PATH === 'string') {
								   audioSrc = process.env.AUDIO_PATH + audioSrc.split('/').pop();
							   }
							   commit('SET_AUDIO', new Howl({
								   src: [audioSrc],
								   sprite: response.data.audio.sprite
							   }))
	
							response.data.components.forEach((item) => {
								Vue.component(item.name, () => import( `@/components/episodes/games/${item.name}.vue`))
							})
							resolve()
						} else {
							episode.router.push('/')
						}
					}, (error) => {
						episode.router.push('/')
					})
			})
		}
	}
})


// WEBPACK FOOTER //
// ./src/store/index.js